import React from "react";
import {
  facebooksvg,
  twitter,
  linkedinsvg,
  youtube,
  komatsuMainLogoFooter,
  instagram
} from "../../assets/images";
import "./footer.scss";
import { ApplicationLink } from "../../interfaces/applicationlink";
import helperFunctions from "../../utils/helperfunctions";
import { useTranslation } from "react-i18next";
import { RESOURCE } from "../../const/resource";
import { useSelector } from "react-redux";
import { selectors as imgSelector } from "../../state/features/header";
import GTMPushEvent from "../../utils/gtminitialize";
import { selectors as globalDataSelector } from "../../state/features/common/globaldata";
import { REGION } from "../../const/linksection";
import { IAppContextProps } from "../App/AppInterface";
import { useAppContext } from "../App/App";
import { confirmDailog } from "../ConfirmDailog";

const Footer = (props: any) => {
    const { isMiningDistributor, isWacMixedFleetDistributor }: IAppContextProps = useAppContext();
    const { roleBasedfilterOptions, isGuestUser, headercurrentuser } = props;
  //multilingual use
  const { t } = useTranslation();
  const { imgBaseUrlSelectors, headerData, myKomatuRegion }: any = useSelector((state) => ({
    imgBaseUrlSelectors: imgSelector.imgbaseUrl(state),
    headerData: imgSelector.currentuser(state),
    myKomatuRegion: imgSelector.myKomatsuRegion(state)
  }));

    const { globalData }: any = useSelector((state) => ({
        globalData: globalDataSelector.globaldata(state),
  }));

  const imgUrl = imgBaseUrlSelectors;

  const updateGTMLog = (item: any, menu = "") => {
    if (menu == "privacy")
      GTMPushEvent({ Path: item?.privacypolicy?.fullurl, PageName: item?.privacypolicy?.title, EventName: item?.privacypolicy?.title, UserDetails: headerData, GlobalDropdown: globalData })
    else if (menu == "terms")
      GTMPushEvent({ Path: item?.termsofuse?.fullurl, PageName: item?.termsofuse?.title, EventName: item?.termsofuse?.title, UserDetails: headerData, GlobalDropdown: globalData })
    else
      GTMPushEvent({ Path: item?.fullurl, PageName: item?.title, EventName: item?.title, UserDetails: headerData, GlobalDropdown: globalData })
  }

  const checkMiningDistributor = (item: any) => {
    if (isMiningDistributor === true && !isWacMixedFleetDistributor) {
      const confimObject = {
        title: 'Message',
        message: t(RESOURCE.MyK_Label_SMining_Distributor_Message),
        confirmmessage: '',
        buttonLabel: {
          yes: t(RESOURCE.MyK_Label_OK),
        },
        yesOnclick: () => { },
        hideNoButton: true
      }
      confirmDailog(confimObject);
    } else {
      updateGTMLog(item);
      helperFunctions.MenuClickEvent(
        item.fullurl,
        item.target
      );
    }
  }
      
  const isShowShoppingCart = helperFunctions.getShowShoppingCartFlg({headercurrentuser, isMiningDistributor, isWacMixedFleetDistributor})

  return (
    <div className="main FooterContainer">
      <div className="footer">
        <div className="footer-column logo-column">
          <img src={imgUrl + komatsuMainLogoFooter} alt="Komatsu Logo" className="logo" />
          <a href={props?.contactDetails?.WebsiteLink} title="Komatsu.com" target="_blank">Komatsu.com</a>
          <div className="social-media">
            {props.socialnwPreFooter?.map(function (
              item: ApplicationLink,
              index: any
            ) {
              let imagesrc = "";
              let imageType = item.name?.toLowerCase();
              let classNameType = ''
              if (imageType.includes("facebook")) {
                classNameType = 'facebook'
                imagesrc = imgUrl + facebooksvg;
              }
              else if (imageType.includes("twitter")) {
                imagesrc = imgUrl + twitter;
                classNameType = 'twitter'
              }
              else if (imageType.includes("instagram")) {
                imagesrc = imgUrl + instagram;
                classNameType = 'instagram'
              }
              else if (imageType.includes("linkedin")) {
                imagesrc = imgUrl + linkedinsvg;
                classNameType = 'linkedin'
              }
              else if (imageType.includes("youtube")) {
                imagesrc = imgUrl + youtube;
                classNameType = 'youtube'
              }
              return (
                <a href="#"><img
                  src={imagesrc}
                  key={item.fullurl}
                  onClick={() => {
                    updateGTMLog(item);
                    helperFunctions.MenuClickEvent(item.fullurl, item.target);
                  }}
                  onKeyDown={() => { }}
                  alt={item.title}
                  title={item.title}
                  className={"socilaMediaImg " + classNameType}
                /></a>
              );
            })}
          </div>
              </div>
        {!isGuestUser &&
            <>
        <div className="footer-column">
          <h3>{t(RESOURCE.MyK_PreFooter_FleetManagement)}
          </h3>
          {props.fleetManagement?.map(function (
            item: ApplicationLink,
            index: any
          ) {
            return (
              <a
                key={item.title}
                href="#."
                title={item.title}
                onClick={() => {
                  updateGTMLog(item);
                  helperFunctions.MenuClickEvent(
                    item.fullurl,
                    item.target
                  );
                }}
              >
                {item.title}
              </a>
            );
          })}
        </div>
        {(myKomatuRegion == REGION.AmericaCorp && isShowShoppingCart) && (
          <div className={roleBasedfilterOptions ? "" : 'd-none'} >
            <div className="footer-column">
              <h3>{t(RESOURCE.MyK_PreFooter_Parts)}</h3>
              {props.partsPreFooter?.map(function (
                item: ApplicationLink,
                index: any
              ) {
                return (
                  <a
                    key={item.title}
                    href="#."
                    title={item.title}
                    onClick={() => {
                      checkMiningDistributor(item);
                    }}
                  >
                    {item.title}
                  </a>
                );
              })}
            </div>
          </div>
        )}
        <div className="footer-column leftborder">
          {props.othersPreFooter?.map(function (
            item: ApplicationLink,
            index: any
          ) {
            return (
              <a
                key={item.title}
                href="#."
                title={item.title}
                onClick={() => {
                  updateGTMLog(item);
                  helperFunctions.MenuClickEvent(
                    item.fullurl,
                    item.target
                  );
                }}
              >
                {item.title}
              </a>
            );
          })}
              </div>
        </>
        }
      </div>
      <div className="stackStylesFooter1">
        <div className="container-fluid mx-2">
          <div className="row">
            <div className="col-12 col-lg-4 footerLeft">
              {props?.versionDetails?.Text}
            </div>
            <div className="col-12 col-lg-4 footerCenter">
              <a
                href="#"
                title={props.privacypolicy.title}
                className=""
                onClick={() => {
                  updateGTMLog(props, "privacy");
                  helperFunctions.MenuClickEvent(
                    props.privacypolicy.fullurl,
                    props.privacypolicy.target
                  );
                }}
              >
                {props.privacypolicy.title}
              </a>{" "}
              <span>|</span>
              <a
                href="#"
                title={props.termsofuse.title}
                onClick={() => {
                  updateGTMLog(props, "terms");
                  helperFunctions.MenuClickEvent(
                    props.termsofuse.fullurl,
                    props.termsofuse.target
                  );
                }}
              >
                {props.termsofuse.title}
              </a>
            </div>
            <div className="col-12 col-lg-4 footerRight">
              {props?.versionDetails?.Version}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Footer;
